"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.C2DMessage = exports.NAMESPACE = void 0;
const common_1 = require("../common");
const message_1 = require("./message");
exports.NAMESPACE = 'Culligan.Protocol.V3.System';
exports.C2DMessage = (0, message_1.createMessage)('command', common_1.System.Command).annotations({
    identifier: `${exports.NAMESPACE}.C2DMessage`,
    title: 'System Message',
    description: 'A Cloud-To-Device message for system commands',
});
//# sourceMappingURL=system.js.map